module.exports = __webpack_public_path__ + "static/media/profile-bg.7f2f9344.jpg";